import React from 'react'
import { connect } from 'react-redux'
import { mapLanguageToPageProps } from 'interview/i18n'
import Layout from 'interview/components/layout'
import SavedComponent from 'interview/components/saved'

function Saved() {
  return (
    <Layout size="small">
      <SavedComponent />
    </Layout>
  )
}

export default connect(mapLanguageToPageProps())(Saved)
